<mat-form-field floatLabel="always">
  <mat-label>{{label | translate}}</mat-label>
  <mat-select [formControl]="control" multiple [placeholder]="showAllPlaceholder ? ('multiSelect.allPlaceholder' | translate) : ''">
    <mat-option *ngFor="let item of dataList" [value]="item.value">{{item.label | translate}}</mat-option>
  </mat-select>
</mat-form-field>
